class NoticePopup extends HTMLElement {
  constructor() {
    super();

    this.cookieName = 'notice-popup';
    this.delay = parseInt(this.getAttribute('data-delay'), 10) || 0;
    this.expireDays = parseInt(this.getAttribute('data-expire'), 10) || 1;

    this._onBodyClick = this.onBodyClick.bind(this);

    // 1) Se já fechou (cookie), não exibe
    if (this.getCookie(this.cookieName) !== '') return;

    // 2) Bind de fechar
    this.querySelectorAll('[data-close-notice-popup]').forEach((el) => {
      el.addEventListener('click', () => this.close());
    });

    document.body.addEventListener('click', this._onBodyClick);

    // 3) Exibir após delay
    window.setTimeout(() => {
      this.open();
    }, this.delay);
  }

  open() {
    this.classList.add('is-open');
  }

  close() {
    this.setCookie(this.cookieName, 'closed', this.expireDays);
    this.classList.remove('is-open');

    // limpa listener
    document.body.removeEventListener('click', this._onBodyClick);
  }

  onBodyClick(event) {
    // clique fora do painel fecha
    const panel = this.querySelector('.halo-notice-popup__panel');
    if (!panel) return;

    if (this.classList.contains('is-open') && !panel.contains(event.target)) {
      // evita fechar se clicou em algo interno ao componente (overlay/painel já tratado)
      // mas como overlay é irmão, o contains falha -> fecha corretamente
      this.close();
    }
  }

  setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }

  getCookie(cname) {
    const name = cname + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1);
      if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
    }
    return '';
  }
}

customElements.define('notice-popup', NoticePopup);